import {createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import {auth, storage,db} from "../firebase";
import React from 'react'
import { useState } from "react";
import {ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import {doc,setDoc } from "firebase/firestore"; 
import { useNavigate,Link } from "react-router-dom";

const Register = () => {

  const [error,setError] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e)=>{
    e.preventDefault();
    const displayName = e.target[0].value;
    const email = e.target[1].value;
    const password = e.target[2].value;
    const file = e.target[3].files[0];



  try {

    const res = await createUserWithEmailAndPassword(auth, email, password);


const storageRef = ref(storage, displayName);

const uploadTask = uploadBytesResumable(storageRef, file);

uploadTask.on(
  (error) => {
    setError(true);
  }, 
  () => {
    getDownloadURL(uploadTask.snapshot.ref)
    .then( async (downloadURL) => {
      await updateProfile(res.user,{
        displayName,
        photoURL:downloadURL,
      });
      await setDoc(doc(db,"users",res.user.uid),{
        uid:res.user.uid,
        displayName,
        email,
        photoURL: downloadURL,
      });

      await setDoc(doc(db,"userChats",res.user.uid),{})
      navigate("/");
    });
  }
);

  } catch (error) {
    setError(true);
  }


  }

  return (
    <body>
  <div>
    <div className='formContainer'>
    <div className="wave"></div>
    <div className="wave"></div>
    <div className="wave"></div>
      <div className='formWrapper'>
        <span className="logo">ConvoConnect! <img src="icons/talking.png" alt=''/> </span>
        <span className="title">Register</span>
        <form onSubmit={handleSubmit} >
          <input type='text' placeholder='Display Name'/>
          <input type='email' placeholder='Email'/>
          <input type='password' placeholder='Password'/>
          <input style={{display:"none"}} type='file' id='file'/>
          <label htmlFor="file">
          <img src="icons/picture.png" alt='pic-icon'/> <span>Be Seen by Friends!</span>
          </label>
          <button>Sign Up</button>

          {error && <span> Something went wrong </span>}
        </form>
        <p>Already have an account? <Link to="/login">Login</Link></p>
      </div>
    </div>
  </div>
</body>
  )
}

export default Register